import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import LanguageSwitcher from '../Common/LanguageSwitcher';
import ThemeToggle from '../Common/ThemeToggle'; // Add this
import { Toaster } from 'react-hot-toast';

const Layout = () => {
  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 ml-72">
        <header className="sticky top-0 z-10 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 px-4 sm:px-6 py-3">
          <div className="flex justify-end items-center space-x-4">
            <ThemeToggle /> {/* Add theme toggle */}
            <LanguageSwitcher />
          </div>
        </header>
        
        <main className="min-h-screen bg-gray-50 dark:bg-gray-800">
          <Outlet />
        </main>
      </div>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </div>
  );
};

export default Layout;